import React from 'react';
import PropTypes from 'prop-types';
import convertEntities from '../utils/convertEntities';
var DropDown = function DropDown(_ref) {
  var _sortOptions;
  var options = _ref.options,
    onChange = _ref.onChange,
    type = _ref.type,
    value = _ref.value;
  var sortOptions = function sortOptions(options) {
    if (type === 'products') {
      return options.sort(function (a, b) {
        return a.label.localeCompare(b.label);
      });
    }
    if (type === 'devices') {
      return options.sort(function (a, b) {
        return a.value.localeCompare(b.value);
      });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "cg__dropdown"
  }, /*#__PURE__*/React.createElement("select", {
    id: type,
    onChange: onChange,
    value: value
  }, (_sortOptions = sortOptions(options)) === null || _sortOptions === void 0 ? void 0 : _sortOptions.map(function (option, index) {
    return /*#__PURE__*/React.createElement("option", {
      key: index,
      defaultValue: value === option.value,
      value: option.value
    }, convertEntities(option.label), " ", option.subTitle ? convertEntities(option.subTitle) : '');
  })), /*#__PURE__*/React.createElement("div", {
    className: "cg__dropdown__arrow"
  }));
};
DropDown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    label: PropTypes.string
  })).isRequired,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired])
};
export default DropDown;